<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useSiteAdmin } from '@/composables/useSiteAdmin'
import Spinner from '@/components/ui/Spinner.vue'
import SitePromoCodes from '@/components/Sites/SitePromoCodes.vue'

// Monetize › Promo codes. The codes discount the site's plans, so the list of
// sellable plans is loaded here and handed to the shared promo component.
const props = defineProps({
	siteId: {
		type: String,
		required: true,
	},
	site: {
		type: Object,
		required: true,
	},
})

const router = useRouter()
const admin = useSiteAdmin(() => props.siteId)
const loading = ref(true)

onMounted(async () => {
	loading.value = true
	await admin.loadPlans()
	loading.value = false
})

// "Create a plan first" → Plans with the create modal open.
const goCreatePlan = () => router.push({ name: 'SitePlans', params: { siteId: props.siteId }, query: { new: '1' } })
</script>

<template>
	<div>
		<Spinner v-if="loading" text="Loading plans…" classes="text-surface-8 mt-24" spinner-color="var(--c-dark-8)" spinner-size="15px" />
		<SitePromoCodes v-else :site-id="siteId" :site="site" :plans="admin.sellablePlans.value" @create-plan="goCreatePlan" />
	</div>
</template>
